var _rect, _defs, _g, _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "url('#gradient')"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient1001",
    gradientTransform: "rotate(45 0.5 0.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#20242c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#636b6d",
    transform: "matrix(5.347974556411115,0,0,5.347974556411115,14.995389821276362,137.7306238116011)",
    stroke: "#dde4e5",
    strokeWidth: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.73-14.22L4.73 0L1.31 0L1.31-14.22L4.73-14.22ZM8.99-3.19L8.99-3.19Q9.78-3.19 10.29-2.73Q10.81-2.27 10.81-1.54Q10.81-0.82 10.29-0.36Q9.78 0.11 8.99 0.11L8.99 0.11Q8.20 0.11 7.69-0.36Q7.18-0.83 7.18-1.54Q7.18-2.26 7.69-2.72Q8.20-3.19 8.99-3.19ZM22.06 0L21.23-2.66L16.53-2.66L15.71 0L12.05 0L17.27-14.22L20.49-14.22L25.74 0L22.06 0ZM18.88-10.23L17.35-5.30L20.41-5.30L18.88-10.23ZM28.66-3.19L28.66-3.19Q29.44-3.19 29.96-2.73Q30.48-2.27 30.48-1.54Q30.48-0.82 29.96-0.36Q29.44 0.11 28.66 0.11L28.66 0.11Q27.87 0.11 27.36-0.36Q26.85-0.83 26.85-1.54Q26.85-2.26 27.36-2.72Q27.87-3.19 28.66-3.19Z"
  }))))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@media (prefers-color-scheme: light) { :root { filter: none; } }\n@media (prefers-color-scheme: dark) { :root { filter: none; } }\n")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7ffdf555ae165955ead75dc1a127eaae.svg";
export { ForwardRef as ReactComponent };